import { ArrowDownTrayIcon } from "@heroicons/react/20/solid";
import { Popover } from "@mantine/core";
import clsx from "clsx";
import type { MouseEvent } from "react";
import { useCallback, useRef, useState } from "react";

import ExcelIcon from "~/components/icons/ExcelIcon";
import useOnClickOutside from "~/hooks/useOnClickOutside.ts";
import {
	generateCompactYearlyUtilisationReportExcel,
} from "~/modules/reports/components/GlobalReportsView/components/UtilisationReportSection/components/TotalUtilisationTableSection/components/UtilisationReportExcelDownloadButtons/generateCompactUtilisationReport.ts";
import type {
	CompactYearlyUtilisationReportExcelTableData,
} from "~/modules/reports/components/GlobalReportsView/components/UtilisationReportSection/components/TotalUtilisationTableSection/components/UtilisationReportExcelDownloadButtons/utilisationReportExcelDownloadButtonsTypes.ts";

interface Props {
	compactReportData: CompactYearlyUtilisationReportExcelTableData[],
	onDownloadExtendedExcelReportClick: () => void;
	year: number
}

const UtilisationReportExcelDownloadButtons = ({
	compactReportData,
	onDownloadExtendedExcelReportClick,
	year,
}: Props) => {
	const [open, setOpen] = useState(false);
	const popoverItemsContainerRef = useRef(null);
	useOnClickOutside(popoverItemsContainerRef, () => setOpen(false));

	const handleMenuButtonClick = useCallback((event: MouseEvent) => {
		event.stopPropagation();
		setOpen((prev) => !prev);
		return event;
	}, []);

	const handleDownloadCompactReportClick = useCallback(async (event: MouseEvent) => {
		event.stopPropagation();
		setOpen(false);
		generateCompactYearlyUtilisationReportExcel(compactReportData, year);
	}, [compactReportData, year]);

	const handleDownloadExtendedExcelReportClick = useCallback((event: MouseEvent) => {
		event.stopPropagation();
		setOpen(false);
		onDownloadExtendedExcelReportClick();
	}, [onDownloadExtendedExcelReportClick]);

	return (
		<Popover position="bottom-end"
				 opened={open}
		>
			<Popover.Target>
				<button type="button"
						className="flex h-full items-center justify-center rounded-full px-2 hover:bg-gray-100"
						onClick={(event) => handleMenuButtonClick(event)}
				>
					<ExcelIcon className="size-5 fill-white" />
				</button>
			</Popover.Target>


			<Popover.Dropdown>
				<div ref={popoverItemsContainerRef}>
					<div>
						<button
							onClick={(event) => handleDownloadCompactReportClick(event)}
							className={clsx(
								"w-full",
								"text-gray-700",
								"hover:bg-gray-100 hover:text-gray-900",
								"flex px-4 py-2 text-sm",
							)}>
							<ArrowDownTrayIcon className="mr-2 size-4" />
							<span>Auslastungreport (kompakt) herunterladen</span>
						</button>
						<button
							onClick={(event) => handleDownloadExtendedExcelReportClick(event)}
							className={clsx(
								"w-full",
								"text-gray-700",
								"hover:bg-gray-100 hover:text-gray-900",
								"flex px-4 py-2 text-sm",
							)}>
							<ArrowDownTrayIcon className="mr-2 size-4" />
							<span>Auslastungreport (detailliert) herunterladen</span>
						</button>
					</div>
				</div>
			</Popover.Dropdown>
		</Popover>
	);
};

export default UtilisationReportExcelDownloadButtons;
